<template>
  <section class="error-page">
    <div class="error-page__mark" aria-hidden="true">
      <svg viewBox="0 0 48 48" width="48" height="48" fill="none">
        <circle cx="24" cy="24" r="22" stroke="currentColor" stroke-width="2.5" />
        <path d="M24 14v13" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
        <circle cx="24" cy="33" r="2" fill="currentColor" />
      </svg>
    </div>
    <h1 class="title">{{ t('errorTitle') }}</h1>
    <!-- Our own copy for an anti-fraud refusal, MTN's statusMessage when MTN refused, else generic. -->
    <p class="lede">{{ errorCode ? t(errorCode) : mnoError || t('errorGeneric') }}</p>

    <button id="retry_button" class="btn btn-primary" @click="tryAgain">{{ t('tryAgainCta') }}</button>
  </section>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useBrandStore } from '@/stores/brandStore'
import { useSubscriptionStore } from '@/stores/subscriptionStore'

const brandStore = useBrandStore()
const { t } = brandStore
const { mnoError, errorCode } = storeToRefs(useSubscriptionStore())

// Full reload rather than a route change: a retry needs a fresh Evina transaction, and the query
// (attribution, lang) is kept.
function tryAgain() {
  window.location.assign(`/${window.location.search}`)
}
</script>

<style scoped>
.error-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-md);
  padding-top: var(--spacing-xl);
  text-align: center;
}

.error-page__mark {
  color: var(--color-error);
}

.title {
  font-family: var(--font-display);
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.05;
  text-wrap: balance;
}

.lede {
  font-size: 0.95rem;
  line-height: 1.6;
  color: var(--color-text-secondary);
  max-width: 34ch;
  margin-bottom: var(--spacing-md);
  overflow-wrap: anywhere;
}
</style>
